import { Button, Tab, Tabs, Autocomplete } from '@mui/material'
import { styled } from '@mui/material/styles';
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";

const fontSize = 10

export const GlobalButton = styled(Button)({
  height: 35,
  textTransform: "none",
});

export const GlobalFixedButton = styled(Button)({
  height: 35,
  textTransform: "none",
  position: 'fixed',
  right: '10px',
  bottom: '10px'
});

export const GlobalSecondaryButton = styled(Button)({
  backgroundColor: "white",
  color: "#0C69B0",
  '&:hover': {
    backgroundColor: 'white',
    color: '#0C69B0'
  },
  '&:disabled': {
    backgroundColor: '#0000001f',
    color: '#00000042',
    border: "none",
  },
  border: "1px solid #0C69B0",
  height: 35,
  textTransform: "none", 
});

export const GlobalTabCollection = styled(Tabs)({
  marginTop: "-20px",
  borderBottom: "1px solid #e8e8e8",
  '& .MuiTabs-indicator': {
    backgroundColor: 'transparent'
  }
});

export const StyledAutocomplete = styled(Autocomplete)({
  '& .MuiAutocomplete-input, & .MuiInputLabel-root': {
    fontSize: fontSize,
  },
});

export const Option = styled('li')({
  fontSize: fontSize,
});

export const StyledTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
  textTransform: "none",
  minWidth: 100,
  [theme.breakpoints.up("sm")]: {
    minWidth: 0,
  },
  fontWeight: theme.typography.fontWeightRegular,
  marginRight: theme.spacing(1),
  color: "rgba(0, 0, 0, 0.85)",
  fontFamily: ["EMPrint"].join(","),
  "&:hover": {
    color: "#40a9ff",
    opacity: 1,
  },
  "&.Mui-selected": {
    color: "#1890ff",
    fontWeight: theme.typography.fontWeightMedium,
    borderBottom: "3px solid #1976d2"
  },
}));

export const FilterButton = ({filtered, children, ...props }) => {
  return <GlobalButton 
    endIcon={filtered ? <FilterAltIcon sx={{ fontSize: 20 }}/> : <FilterAltOffIcon sx={{ fontSize: 20 }}/>}
    {...props}>
      {children}
  </GlobalButton>
}